import React, { useRef, useState, useEffect } from "react";
// import sanityClient from "../../client";
// import Skeleton from "react-loading-skeleton";
// import { urlFor } from "../../utils/urlFor";

import {
  AiFillLeftCircle,
  AiFillRightCircle,
  AiFillCloseCircle,
} from "react-icons/ai";

import "./portfolio-gallery.css";
// import Img from "../image";

const Gallery = ({ galleryImages }) => {
  const [portfolioData, setPortfolioData] = useState({});
  const [slideNumber, setSlideNumber] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleOpenModal = (index) => {
    setSlideNumber(index);
    setOpenModal(true);
  };

  // Close Modal
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // Previous Image
  const prevSlide = () => {
    slideNumber === 0
      ? setSlideNumber(galleryImages.length - 1)
      : setSlideNumber(slideNumber - 1);
  };

  // Next Image
  const nextSlide = () => {
    slideNumber + 1 === galleryImages.length
      ? setSlideNumber(0)
      : setSlideNumber(slideNumber + 1);
  };

  // useEffect(() => {
  //   sanityClient
  //     .fetch(
  //       `*[_type == "portfolio"]{...,  awardsBanner->,  qualityFirstImage->, portfolioImages->,  teamMembers[] {..., image->}}`
  //     )
  //     .then((data) => {
  //       setPortfolioData(data[0]);
  //       setIsLoading(false);
  //     })
  //     .catch(console.error);

  //   sanityClient
  //     .fetch("*[_type == 'gallery']")
  //     .then((data) => {
  //       console.log("gallery data: ", data);
  //     })
  //     .catch(console.error);
  // }, []);

  // useEffect(() => {
  //   console.log("about data: ", portfolioData);
  // }, [portfolioData]);

  return (
    <div>
      {openModal && (
        <div className="sliderWrap">
          <AiFillCloseCircle className="btnClose" onClick={handleCloseModal} />
          <AiFillLeftCircle className="btnPrev" onClick={prevSlide} />
          <AiFillRightCircle className="btnNext" onClick={nextSlide} />
          <div className="fullScreenImage">
            <img src={galleryImages[slideNumber].img} alt="" />
          </div>
        </div>
      )}

      <div className="galleryWrap">
        {galleryImages &&
          galleryImages.slice(0, 15).map((slide, index) => {
            return (
              <div
                className="single"
                key={index}
                onClick={() => handleOpenModal(index)}
              >
                <img
                  src={slide.img}
                  alt=""
                  hash={"LaJku}E4.5ac~VR$InWB_4xVWHt8"}
                  height={"100%"}
                  width={"100%"}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default Gallery;
